var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.loading.isShow}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"_light_grey","size":"70"}},[_vm._v(_vm._s(_vm.loadingText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }